import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  height: 100%;
  margin-bottom: 40px;
`

export const Header = styled.header`
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  > h4, h2 {
    width: '100%';
    color: '#2D2D2D';
  }
`

export const SettingsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
`